import { apiGetRequest, apiGetBlob } from '../../../../utils/api/get';
import { VendorChargingReportResponse, VendorChargingReportFilters } from '../../model/vendorReports';
import { BASE_URL } from '../../../../utils/auth';

export const fetchVendorChargingReportAPI = (
  token: string,
  filters: VendorChargingReportFilters
): Promise<VendorChargingReportResponse> =>
  apiGetRequest<VendorChargingReportResponse>({
    apiUrl: `${BASE_URL}/reports/charging-sessions`,
    token,
    params: {
      startDate: filters.startDate,
      endDate: filters.endDate,
      stationId: filters.stationId,
      chargerId: filters.chargerId,
      userId: filters.userId,
    },
  });

export const downloadVendorChargingReportAPI = (
  token: string,
  filters: VendorChargingReportFilters
): Promise<{ blob: Blob; filename: string }> =>
  apiGetBlob({
    apiUrl: `${BASE_URL}/reports/charging-sessions/download`,
    token,
    params: {
      startDate: filters.startDate,
      endDate: filters.endDate,
      stationId: filters.stationId,
      chargerId: filters.chargerId,
      userId: filters.userId,
      format: filters.format || 'csv',
    },
  });
